"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.socialMediaPlanRoutes = void 0;
exports.socialMediaPlanRoutes = [
    {
        name: 'social-media-plan.list',
        path: ['/', '/q/:q'],
        method: 'GET'
    },
    {
        name: 'social-media-plan.create',
        path: ['/'],
        method: 'POST'
    },
    {
        name: 'social-media-plan.get',
        path: '/:id',
        method: 'GET'
    },
    {
        name: 'social-media-plan.update',
        path: '/:id',
        method: 'PUT'
    },
    {
        name: 'social-media-plan.delete',
        path: '/:id',
        method: 'DELETE'
    },
    {
        name: 'social-media-plan.schedules',
        path: '/:planId/schedules',
        method: 'GET'
    },
    {
        name: 'social-media-plan.schedule.add',
        path: '/:planId/schedules',
        method: 'POST'
    },
    {
        name: 'social-media-plan.schedule.delete',
        path: '/:planId/schedules/:scheduleId',
        method: 'DELETE'
    },
];
